export enum TransformProgramType {
    DIABETES_PREVENTION = 'DIABETES_PREVENTION',
    WEIGHT_MANAGEMENT = 'WEIGHT_MANAGEMENT',
    BLOOD_PRESSURE = 'BLOOD_PRESSURE',
    TEST_PROGRAM = 'TEST_PROGRAM'
}
